import { OnInit, Component, Input, inject } from "@angular/core";
import { TabService } from "@services/tabs/TabService";
import { Pages } from "@constants/pages/Pages";
import { MailMessageModel } from "@app/mailmessages/models/mailMessageModel";
import { MailMessageService } from "@app/mailmessages/service/mailmessage.service";
import { GenericListConfig } from "@app/shared/models/GenericList/GenericList";
import { GenericListFieldType } from "@app/shared/models/GenericList/GenericListField";
import { ModuleType } from "@enums/ModuleType";
import { firstValueFrom } from "rxjs";
import { injectTranslation, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/mailmessages/i18n/scope";
import { GenericListManagerComponent } from "@app/shared/generic-managers/generic-list-manager/generic-list-manager.component";

@Component({
    selector: "uc-mailmessages-overview",
    templateUrl: "./mailmessages-overview.component.html",
    styleUrls: ["./mailmessages-overview.component.scss"],
    imports: [GenericListManagerComponent],
    viewProviders: [provideTranslationScope(scope)],
})
export class MailMessagesOverviewComponent implements OnInit {
    private _tabService = inject(TabService);
    private _mmService = inject(MailMessageService);
    private _translation = injectTranslation(scope);
    pages = inject(Pages);

    @Input() module: ModuleType;

    config: GenericListConfig;

    // Await the scope before the synchronous t() calls in setupConfig().
    async ngOnInit() {
        const [data] = await Promise.all([
            firstValueFrom(this._mmService.getData(this.module)),
            this._translation.ready(),
        ]);

        this.setupConfig(data);
    }

    setupConfig(data: MailMessageModel[]) {
        this.config = <GenericListConfig>{
            name: this._translation.t("overview.title"),
            data: data,
            idProp: "ID",

            allowAdd: false,
            allowEdit: true,
            allowDelete: false,

            fields: [
                {
                    fieldName: "MailTypeDescription",
                    prettyName: this._translation.t("overview.typeHeader"),
                    fieldType: GenericListFieldType.Text,
                    isReadonly: true,
                },
                {
                    fieldName: "Description",
                    prettyName: this._translation.t(
                        "overview.descriptionHeader"
                    ),
                    fieldType: GenericListFieldType.Text,
                },
                {
                    fieldName: "Enabled",
                    prettyName: this._translation.t("overview.sendMailHeader"),
                    fieldType: GenericListFieldType.CheckBox,
                },
            ],
            editOverride: (row: MailMessageModel) => {
                this._tabService.generateTab(
                    this.pages.MailMessagesDetail,
                    row.ID,
                    row.MailTypeDescription
                );
            },
        };
    }
}
